import { NgModule } from '@angular/core';
import {
  SUGGESTIONS_ANY_QUERY_NORMALIZER,
  SUGGESTIONS_SOLR_NORMALIZER,
  SuggestionsAnyQueryNormalizer,
  SuggestionsSolrNormalizer,
} from './converters';

@NgModule({
  providers: [
    {
      provide: SUGGESTIONS_ANY_QUERY_NORMALIZER,
      useExisting: SuggestionsAnyQueryNormalizer,
      multi: true,
    },
    {
      provide: SUGGESTIONS_SOLR_NORMALIZER,
      useExisting: SuggestionsSolrNormalizer,
      multi: true,
    },
  ],
})
export class SearchUtilsModule {}
